module.exports = __webpack_public_path__ + "static/media/landing_img1.af050ef3.jpg";